import { Navigate, useParams } from "react-router-dom";
import { useConvenio } from "@/api/consultas";
import { recursoInexistente } from "@/api/problema";
import { Esqueleto } from "@/componentes/Esqueleto";
import { FaixaDeErro } from "@/componentes/FaixaDeErro";
import { NaoEncontrado } from "@/componentes/NaoEncontrado";
import { ROTA_DOS_CONVENIOS, rotaDoConvenio } from "@/rotas";
import { useSessao } from "@/sessao/useSessao";

/*
 * `/convenios/:id`: o link que só sabe o convênio, como o do detalhe do boleto.
 *
 * Resolve o cedente pelo `pessoa_id` e redireciona com `replace`: este caminho não é um
 * lugar, e guardá-lo no histórico faria o voltar cair aqui e ser mandado de novo para a
 * frente, num laço sem saída.
 */
export function ConvenioPorId() {
  const { id } = useParams();
  const { cliente } = useSessao();
  const { data, error } = useConvenio(cliente, id ?? null);

  if (data !== undefined) {
    return <Navigate to={rotaDoConvenio(data.convenio.pessoa_id, data.convenio.id)} replace />;
  }

  if (recursoInexistente(error)) {
    return (
      <NaoEncontrado
        texto="Convênio não encontrado."
        para={ROTA_DOS_CONVENIOS}
        rotuloDoLink="Convênios"
      />
    );
  }

  if (error !== null) return <FaixaDeErro erro={error} />;

  return <Esqueleto className="h-10 w-64" />;
}
